<script>
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

// Custom Componetns
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import Middleware from "@/helpers/middlewares";
import BookingService from "@/helpers/APIService/booking.service";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      folios: [],
      is_data_loading: true,
      total_credit: parseFloat(0),
      total_debit: parseFloat(0),
      total: parseFloat(0),
      transactions: [],
      modalId: null,

      transactionSubmitted: false,
      isTransactionBtnLoading: false,
      transactionList: [],
      transaction: {
        data: null,
      },
      isMoveTransactionBtnLoading: false,
      moveTransaction: {
        folio: null,
        transaction: null,
      },
    };
  },
  props: {
    currentProps: Object,
  },
  mounted() {
    this.setValues();
    this.getFolios();
  },
  computed: {
    ...authComputed,
  },
  validations: {
    transaction: {
      data: {
        required,
      },
    },
  },
  methods: {
    // Method is used to get folio list
    async getFolios() {
      this.folios = [];
      this.currentProps.folios.map((folio) => {
        folio.name = `#${folio.folio_number} ${folio.guest.first_name} ${folio.guest.last_name}`;
        if (folio.id != this.currentProps.folio.id && !folio.is_deposit_folio) {
          this.folios.push(folio);
        }
      });
    },
    // Method is used to set props values
    async setValues() {
      this.modalId = "add-transaction-modal" + this.currentProps.folio.id;
      this.transactions = [];
      let sumTotal = 0;
      await this.currentProps.folio.folio_transaction.map((transaction) => {
        if (this.currentProps.is_reverse_transaction == true) {
          this.transactions.push(transaction);
          if (!transaction.is_reverse_transaction) {
            this.total_debit = (
              parseFloat(this.total_debit) + parseFloat(transaction.debit)
            ).toFixed(2);
            this.total_credit = (
              parseFloat(this.total_credit) + parseFloat(transaction.credit)
            ).toFixed(2);
            this.total = (
              parseFloat(this.total) +
              (parseFloat(transaction.debit) - parseFloat(transaction.credit))
            ).toFixed(2);
            sumTotal =
              sumTotal +
              parseFloat(transaction.debit) -
              parseFloat(transaction.credit);
            transaction.balance = parseFloat(sumTotal).toFixed(2);
          } else {
            transaction.balance = parseFloat(
              parseFloat(transaction.debit) - parseFloat(transaction.credit)
            ).toFixed(2);
          }
        } else {
          if (transaction.is_reverse_transaction == false) {
            this.transactions.push(transaction);
            this.total_debit = (
              parseFloat(this.total_debit) + parseFloat(transaction.debit)
            ).toFixed(2);
            this.total_credit = (
              parseFloat(this.total_credit) + parseFloat(transaction.credit)
            ).toFixed(2);
            this.total = (
              parseFloat(this.total) +
              (parseFloat(transaction.debit) - parseFloat(transaction.credit))
            ).toFixed(2);
            sumTotal =
              sumTotal +
              parseFloat(transaction.debit) -
              parseFloat(transaction.credit);
            transaction.balance = parseFloat(sumTotal).toFixed(2);
          }
        }
      });
      this.is_data_loading = false;
    },
    // Method is used to get transactions
    getTransactions() {
      this.transactionList = [];
      BookingService.getTransactionListNotInFolio(this.currentProps.booking.id)
        .then((transactions) => {
          transactions.map((transaction) => {
            transaction.title =
              transaction.charge_type +
              " - " +
              transaction.booking_payment.payment_type;
            this.transactionList.push(transaction);
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to handle add new transaction model
    async handleAddTransactionModal(proccess_for) {
      if (proccess_for == "close") {
        this.transactionSubmitted = false;
        this.transaction.data = null;
      } else {
        this.$bvModal.show(this.modalId);
      }
    },
    // Method is used to add mew transation
    addTransaction() {
      this.transactionSubmitted = true;
      this.isTransactionBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isTransactionBtnLoading = false;
        return;
      } else {
        BookingService.transactionInFolio(
          this.currentProps.folio.id,
          this.transaction.data.id,
          "add"
        )
          .then((transaction) => {
            Middleware.notification("Successfully added !!", "success", 3000);
            this.transactions = transaction.booking_transaction;
            this.isTransactionBtnLoading = false;
            this.transactionSubmitted = false;
            this.$bvModal.hide(this.modalId);
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    // Method is used to open folio transaction
    async openMoveTransactionModal(data) {
      await this.getFolios();
      this.moveTransaction.transaction = data;
      this.$refs["add-transaction-folio-modal"].show();
    },
    // Method is used to close folio transaction
    closeMoveTransactionModal() {
      this.isMoveTransactionBtnLoading = false;
      this.moveTransaction.transaction = null;
      this.moveTransaction.folio = null;
    },
    // Method is used to move folio transactions
    moveFolioTransaction() {
      this.isMoveTransactionBtnLoading = true;
      BookingService.moveFolioTransaction(
        this.currentProps.booking.id,
        this.moveTransaction.transaction.id,
        {
          from_folio: this.currentProps.folio.id,
          to_folio: this.moveTransaction.folio.id,
        }
      )
        .then(() => {
          Middleware.notification("Successfully moved !!", "success", 3000);
          this.isMoveTransactionBtnLoading = false;
          this.$refs["add-transaction-folio-modal"].hide();
          this.$emit("updateFolio");
        })
        .catch((error) => {
          errorHandler(error);
          this.isMoveTransactionBtnLoading = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="table-responsive h-auto mb-0">
          <table class="table table-hover mb-0" ref="my-table">
            <thead class="table-light">
              <tr>
                <th
                  :width="!currentProps.folio.is_deposit_folio ? '10%' : '20%'"
                >
                  TX Date #
                </th>
                <th width="15%">Description</th>
                <th
                  :width="!currentProps.folio.is_deposit_folio ? '15%' : '30%'"
                >
                  Payment Account
                </th>
                <th width="5%" class="text-end">Debit</th>
                <th width="5%" class="text-end">Credit</th>
                <th width="5%" class="text-end">Balance</th>
                <th width="5%">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="is_data_loading">
                <td width="10%" class="placeholder-glow">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
                <td width="15%" class="placeholder-glow">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
                <td width="20%" class="placeholder-glow">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
                <td width="10%" class="placeholder-glow">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
                <td width="5%" class="placeholder-glow">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
                <td width="5%" class="placeholder-glow">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
                <td width="5%" class="placeholder-glow">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
                <td width="5%" class="placeholder-glow">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
              <template v-if="transactions.length > 0 && !is_data_loading">
                <template v-for="(data, key) in transactions">
                  <tr v-if="!data.is_reverse_transaction" :key="key">
                    <td>{{ global_format_date(data.created_at) }}</td>
                    <td>
                      <span v-if="data.remark_note != null">
                        {{ data.remark_note }}
                      </span>
                      <span
                        v-else-if="
                          data.description != '' && data.description != null
                        "
                      >
                        {{ data.description }}
                      </span>
                      <span
                        v-else-if="data.comment != '' && data.comment != null"
                      >
                        {{ data.comment }}
                      </span>
                      <span v-else>
                        {{ data.charge_type }}
                      </span>
                      <i
                        class="fa fa-info-circle text-muted d-none"
                        tabindex="0"
                        data-plugin="tippy"
                        data-tippy-animation="scale"
                        data-tippy-arrow="true"
                        v-b-popover.hover="data.remark_note"
                      ></i>
                    </td>
                    <td>
                      <span
                        v-if="
                          data.payment_account != null &&
                          data.transaction_type == 'payment'
                        "
                      >
                        {{ data.payment_account }}
                        {{
                          data.credit_card == null || data.credit_card == ""
                            ? ""
                            : "- *" + data.credit_card.last_digit
                        }}
                      </span>
                      <span v-else> - </span>
                    </td>
                    <td class="text-end">{{ data.debit }}</td>
                    <td class="text-end">{{ data.credit }}</td>
                    <td class="text-end">
                      {{ data.balance }}
                    </td>
                    <td class="text-center">
                      <i
                        class="fas fa-exchange-alt"
                        @click="openMoveTransactionModal(data)"
                        v-if="!currentProps.folio.is_deposit_folio"
                      ></i>
                      <span v-else>-</span>
                    </td>
                  </tr>
                  <tr v-if="data.is_reverse_transaction" :key="key">
                    <td>
                      <del>{{ global_format_date(data.created_at) }}</del>
                    </td>
                    <td>
                      <span v-if="data.remark_note != null">
                        <del> {{ data.remark_note }}</del>
                      </span>
                      <span
                        v-else-if="
                          data.description != '' && data.description != null
                        "
                      >
                        <del> {{ data.description }}</del>
                      </span>
                      <span
                        v-else-if="data.comment != '' && data.comment != null"
                      >
                        <del> {{ data.comment }}</del>
                      </span>
                      <span v-else>
                        <del> {{ data.charge_type }}</del>
                      </span>
                      <i
                        class="fa fa-info-circle text-muted d-none"
                        tabindex="0"
                        data-plugin="tippy"
                        data-tippy-animation="scale"
                        data-tippy-arrow="true"
                        v-b-popover.hover="data.remark_note"
                      ></i>
                    </td>
                    <td>
                      <span
                        v-if="
                          data.payment_account != null &&
                          data.transaction_type == 'payment'
                        "
                      >
                        <del
                          >{{ data.payment_account }}
                          {{
                            data.credit_card == null || data.credit_card == ""
                              ? ""
                              : "- *" + data.credit_card.last_digit
                          }}</del
                        >
                      </span>
                      <span v-else> - </span>
                    </td>
                    <td class="text-end">
                      <del> {{ data.debit }}</del>
                    </td>
                    <td class="text-end">
                      <del>{{ data.credit }}</del>
                    </td>
                    <td class="text-end">
                      <del> {{ data.balance }}</del>
                    </td>
                    <td class="text-center">
                      <span>-</span>
                    </td>
                  </tr>
                </template>
              </template>
              <tr v-if="!is_data_loading && transactions.length == 0">
                <td colspan="7" class="text-center">
                  <img
                    src="@/assets/images/empty.svg"
                    class="img-fluid"
                    alt=""
                  />
                  <p>
                    <span class="text-secondary">No Data Found</span>
                  </p>
                </td>
              </tr>
            </tbody>
            <tfoot v-if="transactions.length > 0 && !is_data_loading">
              <tr>
                <th colspan="3">Total</th>
                <th class="text-end">{{ total_debit }}</th>
                <th class="text-end">{{ total_credit }}</th>
                <th class="text-end">{{ total }}</th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <hr />
    <div class="row text-center d-none">
      <div class="col-12">
        <b-button
          variant="primary"
          class="mt-2"
          @click="handleAddTransactionModal"
        >
          Add Transaction
        </b-button>
      </div>
    </div>
    <!-- Modal is for Add Transaction -->
    <b-modal
      :id="modalId"
      centered
      title="Add Transaction"
      @hidden="handleAddTransactionModal('close')"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <b-form-group class="mb-3" label="Folio">
              <template slot="label">
                Transactions <span class="text-danger">*</span>
              </template>
              <multiselect
                v-model="transaction.data"
                :options="transactionList"
                :show-labels="false"
                track-by="id"
                label="title"
                :class="{
                  'is-invalid':
                    transactionSubmitted && $v.transaction.data.$error,
                }"
                placeholder="Select Transaction"
              ></multiselect>
              <div v-if="transactionSubmitted" class="invalid-feedback">
                <span v-if="!$v.transaction.data.required"
                  >transaction is required.</span
                >
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="row">
          <div class="col-12">
            <b-button
              variant="primary"
              @click="addTransaction"
              :class="{
                disabled: isTransactionBtnLoading || transaction.data == null,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isTransactionBtnLoading"
              ></i>
              Save
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <!-- Modal is for Add Transaction in folio -->
    <b-modal
      ref="add-transaction-folio-modal"
      centered
      title="Move Folio Transaction"
      @hidden="closeMoveTransactionModal"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <b-form-group class="mb-3" label="Folio" label-for="email-input">
              <template slot="label">
                Move to Selected Folio <span class="text-danger">*</span>
              </template>
              <multiselect
                v-model="moveTransaction.folio"
                :options="folios"
                :show-labels="false"
                track-by="id"
                label="name"
                placeholder="Select Folio"
              ></multiselect>
            </b-form-group>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="row">
          <div class="col-12">
            <b-button
              variant="primary"
              @click="moveFolioTransaction"
              :class="{
                disabled:
                  isMoveTransactionBtnLoading || moveTransaction.folio == null,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isMoveTransactionBtnLoading"
              ></i>
              Move
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
